import React from "react";

import { Button, Modal } from "antd";

import "./EnvConfirmModal.css";

export default function EnvConfirmModal({
  headerText,
  bodyText,
  buttonText, // [0: cancel, 1: submit, 2: submit-loading]
  buttonFunctions, // [0: cancel, 1: submit, 2: submit-loading]
  loading,
  width,
  renderExtraContent,
}) {
  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      destroyOnClose
      footer={null}
      width={width ?? "391px"}
      wrapClassName="EnvConfirmModal"
    >
      <div className="envConfirmDel">
        <div className="envConfirmDelTitle">{headerText}</div>
        {bodyText && <div className="envConfirmDelTitleMessage">{bodyText}</div>}
        {renderExtraContent && (
          <div className="envConfirmDelTitleMessage__extra">
            {renderExtraContent}
          </div>
        )}
        <div className="envConfirmDelBtn">
          <Button
            type="default"
            onClick={buttonFunctions[0]}
            disabled={loading}
          >
            {buttonText[0]}
          </Button>
          {loading
            ? (
              <Button
                type="primary"
                onClick={() => { }}
                disabled
                loading={loading}
              >
                <span>{buttonText[2]}</span>
              </Button>
            )
            : (
              <Button
                type="primary"
                onClick={buttonFunctions[1]}
              >
                {buttonText[1]}
              </Button>
            )}

        </div>
      </div>
    </Modal>
  );
}
